// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bg-color[data-v-b2beaf62] {\n    background-color: #b8daff;\n}\n", ""]);
// Exports
module.exports = exports;
